// Module
var code = "<a href=\"javascript:;\" class=\"text-sm sps-btn sps-btn-outline btn-color-static-cancel\" id=\"cancelBtn\"> <i class=\"fa fa-close\"></i> <!-- ko text: _labels.CANCEL --><!-- /ko --> </a>";
// Exports
export default code;